import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class HangTag extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d={`M19.6,3.5L14.3,3c-0.6-0.1-1.2,0.2-1.6,0.6L2.6,13.7c-0.8,0.8-0.8,2.1,0,2.9l5.8,5.8c0.8,0.8,2.1,0.8,2.9,0
                        l10.1-10.1c0.4-0.4,0.7-1,0.6-1.6l-0.5-5.3C21.4,4.4,20.6,3.6,19.6,3.5z M15.6,9.4c-0.6-0.6-0.6-1.6,0-2.2
                        s1.6-0.6,2.2,0s0.6,1.6,0,2.2S16.2,10,15.6,9.4z`}
                />
            </SvgIcon>
        );
    }
}
